import React from 'react';
import { CustomColumn } from '../../../../types/customColumn';

interface PurchaseProductsBodyProps {
  table: any;
  noDataMessage?: string;
}

const PurchaseProductsBody: React.FC<PurchaseProductsBodyProps> = ({
  table,
  noDataMessage = 'No hay productos en esta compra.',
}) => {
  const { getTableBodyProps, page, prepareRow, columns } = table;

  return (
    <tbody {...getTableBodyProps()}>
      {page.length > 0 ? (
        page.map((row: any) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              className="dark:border-gray-700 hover:bg-gray-50 transition dark:hover:bg-graydark/40"
            >
              {row.cells.map((cell: any) => {
                const column = cell.column as CustomColumn<object>;
                return (
                  <td
                    {...cell.getCellProps()}
                    className="text-gray-900 dark:text-gray-200 px-4 py-4 text-[15px] leading-relaxed"
                  >
                    {'customCell' in column && column.customCell
                      ? column.customCell(cell)
                      : cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={columns.length}
            className="text-gray-600 dark:text-gray-300 dark:border-gray-700 border-b py-4 text-center"
          >
            {noDataMessage || 'No hay datos disponibles.'}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default PurchaseProductsBody;
